import axios from './ConfiguredAxios';
import App from 'PublicJs/App';

const EventRegistrations  = {

	saveRegistration: (data) => {
		let url = App.getLocale() + '/event-registrations/multi-add/' + data.eventId;

		return axios.post(url, data);
	}
};

export default EventRegistrations;
